/*
 * Хранилище, управляющее данными приложения
 * будем складывать в localStorage
 *
 * https://developer.mozilla.org/ru/docs/Web/API/Storage
 * Storage.key()
 * Storage.getItem()
 * Storage.setItem()
 * Storage.removeItem()
 * Storage.clear()
*/
/* global DEBUG */

import Server from 'lib/Server'

// private
var instance

// обезательные данные по умолчанию
var DATA = {
  name_expeditor: null,
  login: null,
  email: null,
  gravator_email: null,
  gravator_hash: null,
  auth: null,
  summa: null,
  message: null,
}

var Storage = localStorage

// private methods
function get(name) {
  DATA[name] = (DATA[name] !== undefined)
    ? DATA[name]
    : JSON.parse( Storage.getItem(name) )
  //DEBUG && console.log('get', name, DATA[name])
  return DATA[name]
}

function set(name, data) {
  //DEBUG && console.log('set', name)
  DATA[name] = data
  Storage.setItem(name, JSON.stringify(data) )
}
function remove(name) {
  //DEBUG && console.log('remove ', name)
  Storage.removeItem(name)
}
function extructStorage() {
  for (var item in Storage) {
    DATA[item] = JSON.parse( Storage.getItem(item) )
  }
  return DATA
}

class Store {
  constructor(name) {
    if (instance) {
      return instance
    }
    instance = this

    this.name = name
    extructStorage()
    this.validate()
  }

  get data() {
    return DATA
  }

  // сеттер проксирует данные между Storage и DATA
  $set(model, data) {
    var name = (typeof model == 'object') ? model.name : model
    //DEBUG && console.log('set', name)
    switch (name) {
      case 'login-form':
        this.validate()
        this.extractData(data)
        set(name, data)
        break
      case 'advance-info':
        this.validate()
        this.extractData(data, ['summa'])
        set(name, data)
        break
      case 'settings':
        this.validate()
        this.extractData(data)
        //set(name, data)
        break
      case 'bill-list':
      case 'cnt-list':
      case 'bill-info':
      case 'cnt-info':
      case 'cnt-poezd':
      case 'zayavki-list':
      case 'train-in-way':
      case 'auto-export-cnt':
      case 'auto-import-list':
      //case 'stations-list':
      //case 'auto-carrier-list':
      //case 'auto-carrier-exp-list':
      case 'slots-auto':
      case 'auto-list':
      case 'konos-files-list':
      case 'konos-file':
        // отдельные счета не сохраняем
        this.validate()
        break
      default:
        set(name, data)
        break

    }
    //console.info(name, data);
    this.extractData(data, ['message'])
  }

  // typeof model: Vue or string
  $get(model) {
    var name = (typeof model === 'object') ? model.name : model
    var data = get(name)
     // console.log('store ', name,' data: ',data)
    // если данных нет, то попробуем достать их с сервера
    if ( !data && typeof model == 'object') {
      data = {}
      var server = new Server(model)
      server
        .fetch( this.headers(model) )
        .always( xhr => {
          // если не ошибка, то сохраним данные в DATA
          !xhr.status && this.$set(model, xhr)
          // рапортуем что закончили fetch-ить
          model.$parent && model.$parent.$broadcast('fetchData:completed')
          //  console.log('store get: ',model.$parent)
        })
    }

    return data
  }
  $remove(model) {
    var name = (typeof model === 'object') ? model.name : model
   remove(name)
  }
  // сохраним данные измененой модели на сервер
  $save(model) {
    var server = new Server(model, 'POST')
    server
      .fetch( this.headers(model) )
      .always( xhr => {
        // если не ошибка, то сохраним ответ в DATA
        !xhr.status && this.$set(model, xhr)
        // рапортуем что закончили fetch-ить
        model.$parent && model.$parent.$broadcast('fetchData:completed')
        //  console.log('store save: ',model.$parent)

      })
  }

  // валидация секретного ключа
  // return true|false
  validate() {
    var unixtime = +( new Date().getTime() ) / 1000
    var secret = !!get('secret')
    var create_at = +get('create_at')
    if ( secret && (create_at + 24*60*60 > unixtime) ) {
      set('auth', true)
      return true
    } else {
      Storage.clear()
      for (var item in DATA)
        DATA[item] = null
        Storage.setItem(item, null)
      return false
    }
  }
clear() {
  Storage.clear()
    for (var item in DATA)
    DATA[item] = null
    Storage.setItem(item, null)
}
  headers(model) {
    var headers = model.headers
      ? model.headers
      : { Authorization: 'Bearer ' + get('secret') }
    return {headers}
  }

  // extract data to 'globals'
  extractData(data, arr) {
    // helper
    var _set = (name) => {
      set(name, data[name])
    }
    // если есть arr, то axtract часть data
    if (arr) {
      arr.forEach( name => (data[name] != undefined) && _set(name) )
    }
    else {
      for(var name in data) { _set(name) }
    }
    return data
  }
}

export default Store



/** WEBPACK FOOTER **
 ** ./src/js/Store.js
 **/